import React from "react";
import Button from "../inputs/Button";
import AlertBanner from "../shared/AlertBanner";
import Modal from "../shared/Modal";
import Textarea from "../shared/Textarea";

const DecisionModal = ({
  isOpen,
  onClose,
  decisionNotes,
  setDecisionNotes,
  onConfirm,
}) => {
  const handleClose = () => {
    setDecisionNotes("");
    onClose();
  };

  const footer = (
    <div className="flex justify-end space-x-3">
      <Button variant="outline" onClick={handleClose}>
        Cancel
      </Button>
      <Button
        variant="primary"
        className="bg-emerald-800 hover:bg-emerald-900"
        onClick={onConfirm}
      >
        Confirm Decision Complete
      </Button>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Mark Decision Complete"
      size="sm"
      footer={footer}
    >
      <div className="space-y-4">
        <Textarea
          label="Decision Summary"
          name="decisionNotes"
          placeholder="Provide a brief summary of the panel's decision..."
          rows={4}
          required
          value={decisionNotes}
          onChange={(e) => setDecisionNotes(e.target.value)}
        />

        <AlertBanner
          type="warning"
          message="By marking this decision as complete, you confirm that the panel has reached a final decision. The Platform Admin will be notified for review."
        />
      </div>
    </Modal>
  );
};

export default DecisionModal;
